module.exports = __webpack_public_path__ + "img/organigram-fullscreen.ade1e9b9.svg";